import { Component } from "react";
import { connect } from "react-redux";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

import FormSelect from "components/DigiHapi/FormSelect";

import {
	SET_GOODDEALS_TITLE_EN,
	SET_GOODDEALS_PROMOTION_EN,
	SET_GOODDEALS_DESCRIPTION_EN,
	SET_GOODDEALS_OPENING_TIME_EN,
	SET_GOODDEALS_PRICE_EN,
	SELECT_GOODDEALS_ACTIVITY_CHOICE_EN,
	SET_GOODDEALS_ACTIVITY_NAME_EN,
	SET_GOODDEALS_ACTIVITY_DESCRIPTION_EN,
	SET_GOODDEALS_ACTIVITY_POST_DESCRIPTION_EN
} from "actions/types";

class Step3 extends Component {
	sendState() {
		return this.state;
	}

	isValidated() {
		return true;
	}

	render() {
		const {
			dispatch,
			lang,
			templateId,
			activityNameEn,
			activityDescriptionEn,
			activityPostDescriptionEn,
			choices,
			choiceId
		} = this.props;
		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12}>
					<MDInput
						label="Titre"
						id="title-en"
						fullWidth
						value={lang?.en?.title || ""}
						onChange={e =>
							dispatch({
								type: SET_GOODDEALS_TITLE_EN,
								value: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Description"
						id="descrption-en"
						fullWidth
						multiline
						rows={5}
						value={lang?.en?.description || ""}
						onChange={e =>
							dispatch({
								type: SET_GOODDEALS_DESCRIPTION_EN,
								value: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Prix"
						id="price-en"
						fullWidth
						multiline
						rows={3}
						value={lang?.en?.price || ""}
						onChange={e =>
							dispatch({
								type: SET_GOODDEALS_PRICE_EN,
								value: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Promotion"
						id="promotion-en"
						fullWidth
						value={lang?.en?.promotion || ""}
						onChange={e =>
							dispatch({
								type: SET_GOODDEALS_PROMOTION_EN,
								value: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Période d'ouverture / Horaires"
						id="opening-time-en"
						fullWidth
						multiline
						rows={3}
						value={lang?.en?.openingTime || ""}
						onChange={e =>
							dispatch({
								type: SET_GOODDEALS_OPENING_TIME_EN,
								value: e.target.value
							})
						}
					/>
				</Grid>
				{templateId && (
					<>
						<Grid item xs={12}>
							<MDTypography variant="button" fontWeight="medium">
								Choix pour la recherche de partenaire
							</MDTypography>
						</Grid>
						{choices && (
							<Grid item xs={12}>
								<FormSelect
									label="Sélectionner le choix à mettre à jour"
									value={choiceId}
									placeholder="Choix"
									options={Object.values(choices).map(({ name }) => ({
										value: name,
										label: name
									}))}
									onChange={e =>
										dispatch({
											type: SELECT_GOODDEALS_ACTIVITY_CHOICE_EN,
											payload: e.target.value
										})
									}
								/>
							</Grid>
						)}
						{choices && (
							<Grid item xs={12}>
								<MDInput
									label="Nom"
									id="set-name-en"
									fullWidth
									value={activityNameEn || ""}
									onChange={e =>
										dispatch({
											type: SET_GOODDEALS_ACTIVITY_NAME_EN,
											payload: e.target.value
										})
									}
								/>
							</Grid>
						)}
						<Grid item xs={12}>
							<MDInput
								label="Description"
								id="description-en"
								fullWidth
								multiline
								rows={5}
								value={activityDescriptionEn || ""}
								onChange={e =>
									dispatch({
										type: SET_GOODDEALS_ACTIVITY_DESCRIPTION_EN,
										payload: e.target.value
									})
								}
							/>
						</Grid>
						<Grid item xs={12}>
							<MDInput
								label="Description après photo"
								id="post-description-en"
								fullWidth
								multiline
								rows={3}
								value={activityPostDescriptionEn || ""}
								onChange={e =>
									dispatch({
										type: SET_GOODDEALS_ACTIVITY_POST_DESCRIPTION_EN,
										payload: e.target.value
									})
								}
							/>
						</Grid>
					</>
				)}
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		lang,
		templateId,
		activityNameEn,
		activityDescriptionEn,
		activityPostDescriptionEn,
		choices,
		choiceId
	} = state.gooddealReducer;
	return {
		lang,
		templateId,
		activityNameEn,
		activityDescriptionEn,
		activityPostDescriptionEn,
		choices,
		choiceId
	};
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(
	Step3
);
